import { h } from 'preact';
import { Text, IntlProvider } from 'preact-i18n';
import { TertiaryNav } from '@cube/blocks';
import { CurrencyIndicator } from '../currency-indicator';
import { camel } from '../../lib/util';
import definition from '../../intl.json';
import style from './style.less';
import cx from 'classnames';

/**
 * A specific implementation of the Tertiary nav for use on the Stock Details Desktop page.
 */
const StockDetailsNav = ({ symbol, type, uniqueSymbol, current, showCurrencyIndicator, menus, locale, showProfileInfo, device, liteMenus=false, ...props }) => {
	if (uniqueSymbol) symbol = uniqueSymbol;
	if (type) type = type.toLowerCase();

	let nav = (menus[type] || menus.default).reduce((items,item) => {
		// Exclude the non-lite options
		if (liteMenus && !item.lite) return items;
		// Exclude the item from the nav if it's restricted for the provided locale
		if (item.limitedLocales && item.limitedLocales.indexOf(locale) >= 0) return items;
		// If this symbol does not have any profile data, do not include the link either
		if (device && item.url.indexOf('/profile/') > -1 && !showProfileInfo) return items;
		// Otherwise add the necessary properties before including in the list of items to send to the blocks component
		items.push(prepItemForInclusionInNav(item));
		return items;
	}, []);

	function prepItemForInclusionInNav(item) {
		item.url = item.url.replace('{symbol}', symbol);
		if (item.label && typeof item.label === 'string') {
			// We force the scope here to stop finance-blocks from trumping our namespace, which is
			// currently happening. I.E., it looks for 'finance-blocks.stock-details-nav.VALUE'
			item.label = (
				<IntlProvider scope="finance-components.stock-details-nav" definition={definition}>
					<Text id={`${camel(item.label)}`}>{item.label}</Text>
				</IntlProvider>
			);
		}
		return item;
	}

	return (
		<div class={style.navContainer}>
			<TertiaryNav items={nav} class={cx(style.stockDetailsNav, style.overrideBlocks)} device="desktop" current={current} {...props} />
			{
				type !== 'index' && showCurrencyIndicator && (
					<div class={style.navFooter}>
						<CurrencyIndicator symbol={symbol} />
					</div>
				)
			}
		</div>
	);
};

export default StockDetailsNav;
